'use client'

import { useAtomValue } from 'jotai'
import { errorAtom } from '@/src/stores/route-machine/atoms'
import { getErrorToDisplay } from '@/src/utils/error'
import { Banner } from '../ui/banner'
import { TradeErrorMessage } from './trade-error-message'

export default function ErrorHeader() {
  const error = useAtomValue(errorAtom)

  if (!error) return null

  const deepErrorMessage = getErrorToDisplay(error)?.message
  return (
    <Banner
      alertTitle='Trade failed'
      description={<TradeErrorMessage error={deepErrorMessage} />}
      variant='warning'
      className='pl-6 animate-fade-in'
    />
  )
}
